import { useEffect, useState } from "react";
import {
  getExistingSubscription,
  pushSupported,
  subscribePush,
  unsubscribePush,
} from "../../lib/push";

/**
 * Vague E.1 · Toggle Web Push.
 *
 * Affiche un bouton "Activer/Désactiver" les notifications system.
 * No-op si le navigateur ne supporte pas le push.
 */
export function PushToggle() {
  const [supported, setSupported] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setSupported(pushSupported());
    void getExistingSubscription().then((s) => setEnabled(Boolean(s)));
  }, []);

  if (!supported) return null;

  const onToggle = async () => {
    setBusy(true);
    setError(null);
    try {
      if (enabled) {
        await unsubscribePush();
        setEnabled(false);
      } else {
        await subscribePush();
        setEnabled(true);
      }
    } catch (e) {
      setError(e instanceof Error ? e.message : "Erreur.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col items-end">
      <button
        type="button"
        onClick={onToggle}
        disabled={busy}
        className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
          enabled
            ? "bg-accent-500 text-white hover:bg-accent-600"
            : "bg-navy-50 text-navy-700 hover:bg-navy-100"
        }`}
        title={enabled ? "Notifications activées" : "Activer les notifications"}
      >
        {busy ? "…" : (
          <span className="inline-flex items-center gap-1">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              {enabled ? (
                <>
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </>
              ) : (
                <>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                  <path d="M18.63 13A17.89 17.89 0 0 1 18 8" />
                  <path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14" />
                  <path d="M18 8a6 6 0 0 0-9.33-5" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </>
              )}
            </svg>
            {enabled ? "Notifs ON" : "Notifs OFF"}
          </span>
        )}
      </button>
      {error ? (
        <span className="mt-1 max-w-[200px] text-right text-[10px] text-red-600">
          {error}
        </span>
      ) : null}
    </div>
  );
}
